import React, { useState } from "react";
import PhotoModal from "./PhotoModal";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

type Props = {
    assetTypeId: number,
    exclusionReasonTypeId: number,
    onChange: Function,
    onDelete: Function,
    photos: Array<any>,
};

/**
 * Photo List Component
 */
export default ({
    assetTypeId,
    exclusionReasonTypeId,
    onChange,
    onDelete,
    photos,
}: Props) => {
    const classes = makeStyles(styles)();
    const [modalVisible, setModalVisible] = useState(false);
    const [index, setIndex] = useState(-1);

    const handlePress = (value: any) => {
        setIndex(value);
        setModalVisible(true);
    };

    const onModalHide = () => setModalVisible(false);

    return (
        <>
            <div className={classes.photoList}>
                <div className={classes.listWrp}>
                    {photos.map((item, index) => {
                        return (
                            <img
                                key={index}
                                src={item.thumbnail}
                                className={classes.photoListItemImage}
                                onClick={() => handlePress(index)}
                                role="button"
                                aria-label={`captured-image-${index}`}
                            />
                        );
                    })}
                </div>
            </div>
            <PhotoModal
                assetTypeId={assetTypeId}
                exclusionReasonTypeId={exclusionReasonTypeId}
                onChange={onChange}
                onDelete={onDelete}
                onHide={onModalHide}
                photo={photos[index] || {}}
                visible={modalVisible}
            />
        </>
    );
};
